import fetchApi from "../fetchApi";
export const RequestCreateSellOrder = async (
    {
        corporate_customer_id = '',
        total_cost= '',
        total_tax='',
        office_id = '',
        quantity = '',
        cards = [],
        specialty_items = [],
        payments = [],
        total_service_fee = '',
        skip_activation_fee = false
    }) => {

        const payload = {
            "total_cost": total_cost,
            "total_tax": total_tax,
            "office_id": office_id,
            "quantity": quantity,
            "cards": cards,
            "specialty_items": specialty_items,
            "payments": payments,
            "skip_activation_fee": skip_activation_fee
        }

        // The BFF drops anything it is not told to forward, so the fee bps-go
        // recalculates is still sent for the total_cost check to line up.
        if (total_service_fee !== '') {
            payload.total_service_fee = total_service_fee
        }

        if(corporate_customer_id !== '') {
            payload.corporate_customer_id = corporate_customer_id
        }

    const options = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(payload),
        redirect: 'follow'
    }

    return await fetchApi(`card-issuing/sell-order/regular`, options);
};